import { createContext, useContext } from "react";

export const ConfigContext = createContext(null);

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used inside ConfigContext.Provider");
  }
  return context;
};